/* eslint-disable react/prop-types */
import React from 'react';

/* Line icons in the same stroke style as the arrow in Buttons.jsx. All take
   `currentColor` so the surrounding component decides the colour. */

const Svg = ({ children, ...rest }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...rest}
  >
    {children}
  </svg>
);

export const DocumentIcon = (props) => (
  <Svg {...props}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" />
    <path d="M14 3v5h5" />
    <path d="M9 13h6M9 17h4" />
  </Svg>
);

export const ClipboardIcon = (props) => (
  <Svg {...props}>
    <path d="M9 5H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="1" />
    <path d="m9 14.5 2 2 4-4.5" />
  </Svg>
);

export const CalendarIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="5" width="18" height="16" rx="2.5" />
    <path d="M3 10h18M8 3v4M16 3v4" />
    <path d="M8 15h3" />
  </Svg>
);

export const BellIcon = (props) => (
  <Svg {...props}>
    <path d="M6 16v-5a6 6 0 1 1 12 0v5l1.5 2h-15L6 16Z" />
    <path d="M10 21a2 2 0 0 0 4 0" />
  </Svg>
);

export const SparklesIcon = (props) => (
  <Svg {...props}>
    <path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" />
    <path d="m19 16 .8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8L19 16Z" />
  </Svg>
);

export const ToothIcon = (props) => (
  <Svg {...props}>
    <path d="M7.4 3C5 3 3.4 5.2 3.7 8c.2 2.2 1.2 3.4 1.5 5.5.3 2.5.6 7.5 2.6 7.5 1.6 0 1.8-4 4.2-4s2.6 4 4.2 4c2 0 2.3-5 2.6-7.5.3-2.1 1.3-3.3 1.5-5.5.3-2.8-1.3-5-3.7-5-1.8 0-2.6 1-4.6 1S9.2 3 7.4 3Z" />
  </Svg>
);

export const UserIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
  </Svg>
);

export const ShieldIcon = (props) => (
  <Svg {...props}>
    <path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.4 7.5 9.5 4.3-1.1 7.5-4.9 7.5-9.5V6L12 3Z" />
    <path d="m9 12 2 2 4-4" />
  </Svg>
);

export const ServerIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="4" width="18" height="6" rx="2" />
    <rect x="3" y="14" width="18" height="6" rx="2" />
    <path d="M7 7h.01M7 17h.01" />
  </Svg>
);

export const MapPinIcon = (props) => (
  <Svg {...props}>
    <path d="M12 21s-6-5.3-6-10a6 6 0 0 1 12 0c0 4.7-6 10-6 10Z" />
    <circle cx="12" cy="11" r="2" />
  </Svg>
);

export const LinkIcon = (props) => (
  <Svg {...props}>
    <path d="M10 13a5 5 0 0 0 7.1.5l3-3a5 5 0 0 0-7.1-7.1L11.3 5" />
    <path d="M14 11a5 5 0 0 0-7.1-.5l-3 3a5 5 0 0 0 7.1 7.1L12.7 19" />
  </Svg>
);

export const UsersIcon = (props) => (
  <Svg {...props}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" />
    <path d="M16 4.6a3.5 3.5 0 0 1 0 6.8" />
    <path d="M18 14.2c2.2.7 3.5 2.6 3.5 5.8" />
  </Svg>
);

export const GiftIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M12 8v13" />
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
    <path d="M12 8c-1.5-3-5-3.5-5-1s3.5 1.5 5 1c1.5.5 5 1.5 5-1s-3.5-2-5 1Z" />
  </Svg>
);

export const CheckIcon = (props) => (
  <Svg strokeWidth="2.4" {...props}>
    <path d="m5 12.5 4.5 4.5L19 7.5" />
  </Svg>
);

export const ICONS = {
  document: DocumentIcon,
  clipboard: ClipboardIcon,
  calendar: CalendarIcon,
  bell: BellIcon,
  sparkles: SparklesIcon,
  tooth: ToothIcon,
  user: UserIcon,
  shield: ShieldIcon,
  server: ServerIcon,
  mapPin: MapPinIcon,
  link: LinkIcon,
  users: UsersIcon,
  gift: GiftIcon,
  check: CheckIcon,
};
